import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export function Eyebrow({ children, className, dark }) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <span className={cn("h-px w-8", dark ? "bg-brand-gold" : "bg-brand-gold")} />
      <span className="text-xs uppercase tracking-editorial font-semibold text-brand-gold">
        {children}
      </span>
    </div>
  );
}

export function SectionHeading({ eyebrow, title, className, dark }) {
  return (
    <div className={cn("max-w-3xl", className)}>
      {eyebrow && (
        <Reveal>
          <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
        </Reveal>
      )}
      <Reveal delay={1}>
        <h2
          className={cn(
            "mt-6 font-serif tracking-tight leading-[1.05] whitespace-pre-line text-3xl sm:text-4xl lg:text-5xl",
            dark ? "text-brand-ivory" : "text-brand-graphite"
          )}
        >
          {title}
        </h2>
      </Reveal>
    </div>
  );
}

// Primary / secondary editorial CTA
export function CTAButton({ children, href, to, variant = "primary", className, onClick, type, dark, ...props }) {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold tracking-wide transition-all duration-300 focus-visible:outline-none";
  const variants = {
    primary:
      "bg-brand-bordeaux text-brand-ivory hover:bg-brand-wine hover:-translate-y-0.5 shadow-[0_8px_30px_-12px_rgba(90,16,37,0.6)]",
    gold:
      "bg-brand-gold text-brand-graphite hover:bg-[#c9a968] hover:-translate-y-0.5",
    outline: dark
      ? "border border-brand-ivory/30 text-brand-ivory hover:border-brand-gold hover:text-brand-gold"
      : "border border-brand-bordeaux/25 text-brand-bordeaux hover:border-brand-bordeaux hover:bg-brand-bordeaux hover:text-brand-ivory",
  };
  const cls = cn(base, variants[variant], className);
  if (to) {
    return (
      <Link to={to} onClick={onClick} className={cls} {...props}>
        {children}
        <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
      </Link>
    );
  }
  const Comp = href ? "a" : "button";
  return (
    <Comp href={href} type={type} onClick={onClick} className={cls} {...props}>
      {children}
      <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
    </Comp>
  );
}
